
import { defineComponent } from "vue";

//import ScoresGraphsContent from "./ScoresGraphsContent.vue";
import ScoresContent from "./ScoresContent.vue";

export default defineComponent({
    name: "ScoreGroupsPanel",
    components: {
        //  ScoresGraphsContent,
        ScoresContent
    },
});
